const Refresh = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="12" fill="#344054" fillOpacity="0.6" />
      <path
        d="M15.7601 8.23333C15.2667 7.73656 14.6798 7.34237 14.0334 7.07349C13.3869 6.8046 12.6936 6.66633 11.9934 6.66666C9.04675 6.66666 6.66675 9.05333 6.66675 12C6.66675 14.9467 9.04675 17.3333 11.9934 17.3333C14.4801 17.3333 16.5534 15.6333 17.1467 13.3333H15.7601C15.4855 14.113 14.9756 14.7882 14.301 15.2659C13.6263 15.7435 12.82 16 11.9934 16C9.78675 16 7.99341 14.2067 7.99341 12C7.99341 9.79333 9.78675 8 11.9934 8C13.1001 8 14.0867 8.46 14.8067 9.18667L12.6601 11.3333H17.3267V6.66666L15.7601 8.23333Z"
        fill="white"
      />
    </svg>
  )
}

export default Refresh
